import React from 'react';
import Cookies from 'js-cookie';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import { Particles } from '../components/Particles.tsx';
import { Container, Typography, Box, Paper, useTheme, Divider, Link } from '@mui/material';

const CookiePolicy: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token');
  const theme = useTheme();
  const darkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ position: 'relative', height: '100vh', width: '100vw', overflowX: 'hidden', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1, position: 'fixed' }}>
        <Particles />
      </div>
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', pt: { xs: '90px', md: '100px' }, pb: 4 }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: '24px', background: darkMode ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.8)', backdropFilter: 'blur(10px)', border: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)', color: darkMode ? 'rgba(255,255,255,0.85)' : '#333' }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', textAlign: 'center' }}>
              Cookie Policy
            </Typography>
            <Typography variant="subtitle1" sx={{ textAlign: 'center', mb: 4, opacity: 0.7 }}>
              Last updated: April 2026
            </Typography>
            <Divider sx={{ mb: 4, borderColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)' }} />

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>1. What Are Cookies?</Typography>
            <Typography variant="body1" paragraph>
              Cookies are small text files that are stored on your computer or mobile device when you visit a website. LinkLearning (<Link href="https://linklearning.net/" target="_blank" color="inherit">https://linklearning.net/</Link>) uses cookies to ensure the core functionalities of the platform operate securely and efficiently.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>2. How We Use Cookies</Typography>
            <Typography variant="body1" paragraph>
              We primarily use cookies for authentication and session management. When you log into LinkLearning, we store a secure token in your browser's cookies. This token prevents you from having to log in repeatedly every time you navigate to a new page or reload the application.
            </Typography>

            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>3. Types of Cookies We Use</Typography>
            <Typography variant="body1" paragraph>
              <strong>Essential Cookies:</strong> These are strictly necessary for the platform to function. For example, our authentication cookies ensure you can access your dashboard securely. <br />
              <strong>Functional Cookies:</strong> These may be used to remember your preferences (such as Light or Dark mode settings) to provide a tailored user experience.
            </Typography>
            
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: darkMode ? 'white' : '#1a237e', mt: 3 }}>4. Managing Your Cookie Preferences</Typography>
            <Typography variant="body1" paragraph>
              You can control or delete cookies through your browser settings. However, please note that disabling cookies will prevent you from logging into your LinkLearning account, as our secure authentication system relies on them. If you have questions about our use of cookies, contact us at <strong>official.linklearning@gmail.com</strong>.
            </Typography>

          </Paper>
        </Container>
      </Box>
    </Box>
  );
};

export default CookiePolicy;